<template>
  <div class="pulse-iframe-wrapper">
    <iframe
      :src="urlPulse()"
      ref="pulseIframe"
      title="Pulse"
      frameborder="0"
      scrolling="yes"
      @load="onIframeLoad"
    ></iframe>
  </div>
</template>

<script>
import { SET_LAYOUT_CONFIG } from "@/core/services/store/config.module";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME
} from "@/core/services/store/htmlclass.module";
import config from "@/core/config/layout.config.json";
import JwtService from "@/core/services/jwt.service";
import { mapGetters } from "vuex";

export default {
  name: "pulse",

  data() {
    return {
      tokenComunicante: JwtService.getToken(),
      pulseUrl: process.env.VUE_APP_PULSE_URL || "http://localhost:5173"
    };
  },

  mounted() {
    this.hideChatwoot();
    this.hideHeader();

    window.addEventListener("message", this.handleIframeMessage);
  },

  computed: {
    ...mapGetters(["currentUserPersonalInfo"])
  },

  methods: {
    urlPulse() {
      return this.pulseUrl;
    },

    getPulseOrigin() {
      return new URL(this.pulseUrl).origin;
    },

    onIframeLoad() {
      this.enviarToken();
    },

    enviarToken() {
      const iframe = this.$refs.pulseIframe;
      const token = JwtService.getToken();

      if (!iframe || !iframe.contentWindow || !token) {
        console.warn("[PULSE PARENT] iframe ou token indisponível");
        return;
      }

      iframe.contentWindow.postMessage(
        {
          type: "PULSE_AUTH",
          accessToken: token
        },
        this.getPulseOrigin()
      );
    },

    handleIframeMessage(event) {
      if (event.origin !== this.getPulseOrigin()) return;

      if (event.data?.type === "PULSE_IFRAME_READY") {
        this.enviarToken();
      }

      /**
       * Mantive esse fallback porque no código que te passei no pulse-front
       * ele também emite VALORA_IFRAME_READY por compatibilidade.
       * Depois que tudo estiver estável, pode remover se quiser.
       */
      if (event.data?.type === "VALORA_IFRAME_READY") {
        this.enviarToken();
      }
    },

    hideChatwoot() {
      if (window.$chatwoot) {
        try {
          const exapnded_text = document.getElementById(
            "woot-widget--expanded__text"
          );

          if (exapnded_text) exapnded_text.style.display = "none";

          const widget_bubble_icon = document.getElementById(
            "woot-widget-bubble-icon"
          );

          if (widget_bubble_icon) widget_bubble_icon.style.margin = "14px";

          const widget_bubble = document.querySelector(".woot-widget-bubble");

          if (widget_bubble) widget_bubble.style.height = "unset";
        } catch (error) {
          // console.log(error);
        }
      }
    },

    showChatwoot() {
      if (window.$chatwoot) {
        try {
          const exapnded_text = document.getElementById(
            "woot-widget--expanded__text"
          );

          if (exapnded_text) exapnded_text.style.display = "flex";

          const widget_bubble_icon = document.getElementById(
            "woot-widget-bubble-icon"
          );

          if (widget_bubble_icon) {
            widget_bubble_icon.style.margin = "14px 8px 14px 16px";
          }

          const widget_bubble = document.querySelector(".woot-widget-bubble");

          if (widget_bubble) widget_bubble.style.height = "48px";
        } catch (error) {
          // console.log(error);
        }
      }
    },

    hideHeader() {
      let newConfig = JSON.parse(JSON.stringify(config));

      this.$store.dispatch(SET_BREADCRUMB, [{ title: "Pulse" }]);
      this.$store.dispatch(ADD_BODY_CLASSNAME, "aside-minimize");

      newConfig.header.self.display = false;
      newConfig.subheader.display = false;
      newConfig.styleContetnt = { padding: "0" };
      newConfig.styleContainer = {
        "max-width": "100%",
        margin: 0
      };
      newConfig.wrapper = { "padding-top": 0 };
      newConfig.scrollTop.self.display = false;
      newConfig.aside.self.minimize.hoverable = true;

      this.$store.dispatch(SET_LAYOUT_CONFIG, newConfig);
    }
  },

  beforeDestroy() {
    window.removeEventListener("message", this.handleIframeMessage);

    this.$store.dispatch(REMOVE_BODY_CLASSNAME, "aside-minimize");

    this.showChatwoot();
  }
};
</script>

<style>
.pulse-iframe-wrapper {
  width: 100%;
  height: 100vh;
  overflow: auto;
}

.pulse-iframe-wrapper iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  overflow: auto;
}

.pulse
  .v-progress-circular--indeterminate:not(.v-progress-circular--visible)
  > svg,
.pulse
  .v-progress-circular--indeterminate:not(.v-progress-circular--visible)
  .v-progress-circular__overlay {
  animation-play-state: running !important;
}

.pulse .statistics {
  width: 100%;
}

.aside-menu .menu-nav > .menu-item > .menu-heading .menu-text,
.aside-menu .menu-nav > .menu-item > .menu-link .menu-text {
  font-weight: 400 !important;
  font-size: 13px !important;
  text-transform: initial !important;
  font-family: Poppins, Helvetica, "sans-serif" !important;
}

.aside-menu .menu-nav > .menu-item > .menu-heading .menu-icon,
.aside-menu .menu-nav > .menu-item > .menu-link .menu-icon {
  font-size: 19.5px !important;
}

.pulse div.flex.xs12.md3:first-of-type {
  padding-left: 0px !important;
}

#kt_brand {
  flex: none !important;
}

#kt_aside_menu {
  margin-top: 13px !important;
  margin-bottom: 13px !important;
}
</style>
